var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',{staticClass:"input-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-text-field',_vm._b({ref:"profileAddressInput",class:[
      _vm.label ? 'mt-1' : '',
      'py-1',
      'pr-16',
      'pl-5',
      'mt-2.5',
      'whitespace-nowrap',
      'bg-slate-100',
      'rounded-[32px]',
      'text-slate-500',
      'max-md:pr-5',
       _vm.$attrs.class, // Preserve existing classes from $attrs
    ],attrs:{"value":_vm.input,"label":_vm.label ? '' : 'Enter address',"dense":_vm.dense,"outlined":_vm.outlined,"prepend-inner-icon":"mdi-map-marker","rules":_vm.getRules,"id":"profile-address-input"},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [(_vm.help)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","x-small":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-help-circle-outline")])],1)]}}],null,false,775014010)},[_c('span',[_vm._v(_vm._s(_vm.help))])]):_vm._e()]},proxy:true}])},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }